import { Icon } from '@components/Icon.tsx';
import { IconType } from '@src/IconType.ts';
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  type PopoverPanelProps,
} from '@headlessui/react';
import { classNames } from '@utils/classNames.ts';

export type InfoTextProps = {
  text: string | undefined;
  className?: string;
  withoutMargin?: boolean;
  placement?: PopoverPanelProps['anchor'];
};

export const InfoText = ({
  text,
  className,
  withoutMargin = false,
  placement = 'bottom end',
}: InfoTextProps) => {
  if (!text) {
    return <></>;
  }
  return (
    <Popover className={classNames('relative contents', className)}>
      <PopoverButton data-testid="popover-btn" className="cursor-pointer">
        <Icon
          type={IconType.Question}
          className={classNames(
            !withoutMargin && 'ml-[5px]',
            'h-6 w-6 text-slate-500',
          )}
        />
      </PopoverButton>

      <PopoverPanel
        className="!max-w-80 min-w-60 px-3 py-[7px] bg-slate-500 text-white text-md leading-6 rounded-lg drop-shadow-infoText whitespace-pre-line z-[var(--z-index-tooltip)]"
        data-testid="popover-panel"
        anchor={placement}
      >
        {text}
      </PopoverPanel>
    </Popover>
  );
};
